// assets/momax-footer.js

// -- Constants
const MOBILE_BREAKPOINT = 740;

// -- Functions
function isMobileViewport() {
  return window.innerWidth <= MOBILE_BREAKPOINT;
}

function toggleMenu(menuItem, forceState) {
  if (!menuItem) return;
  const toggleBtn = menuItem.querySelector('.momax-footer__menu-toggle');
  const isOpen = menuItem.classList.contains('is-open');
  const shouldOpen = typeof forceState === 'boolean' ? forceState : !isOpen;

  if (shouldOpen) {
    // Single open: close other open menus in the same navigation container
    const nav = menuItem.closest('.momax-footer__nav');
    if (nav) {
      const openSiblings = nav.querySelectorAll('.momax-footer__menu.is-open');
      openSiblings.forEach((sibling) => {
        if (sibling !== menuItem) {
          sibling.classList.remove('is-open');
          const siblingBtn = sibling.querySelector('.momax-footer__menu-toggle');
          if (siblingBtn) {
            siblingBtn.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    menuItem.classList.add('is-open');
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
  } else {
    menuItem.classList.remove('is-open');
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
  }
}

// -- Listeners
function handleFooterClick(event) {
  if (!isMobileViewport()) return;

  const toggleBtn = event.target.closest('.momax-footer__menu-toggle');
  if (!toggleBtn) return;

  const menuItem = toggleBtn.closest('.momax-footer__menu');
  if (!menuItem) return;

  event.preventDefault();
  toggleMenu(menuItem);
}

function handleBlockSelect(event) {
  if (!isMobileViewport()) return;
  const target = event.target;
  const menuItem = target.classList.contains('momax-footer__menu')
    ? target
    : target.closest('.momax-footer__menu');
  if (menuItem) {
    toggleMenu(menuItem, true);
  }
}

function handleBlockDeselect(event) {
  if (!isMobileViewport()) return;
  const target = event.target;
  const menuItem = target.classList.contains('momax-footer__menu')
    ? target
    : target.closest('.momax-footer__menu');
  if (menuItem) {
    toggleMenu(menuItem, false);
  }
}

// -- Lifecycle hooks
function initMomaxFooter() {
  const footers = document.querySelectorAll('.momax-footer');
  footers.forEach((footer) => {
    if (footer.dataset.momaxFooterInitialized) return;
    footer.dataset.momaxFooterInitialized = 'true';

    footer.addEventListener('click', handleFooterClick);
    footer.addEventListener('shopify:block:select', handleBlockSelect);
    footer.addEventListener('shopify:block:deselect', handleBlockDeselect);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMomaxFooter);
} else {
  initMomaxFooter();
}

document.addEventListener('shopify:section:load', initMomaxFooter);
